<template>
	<div class="share">
		<el-form label-width="120px" ref="formScreen" :model="formScreen">
			<el-col :span="6">
				<el-form-item
					label="选择分公司"
					prop="branchCompany"
					v-if="[1].includes(UserInfo.type)"
				>
					<el-select
						v-model="formScreen.branchCompany"
						placeholder="请选择"
						@change="selectChange($event, 'listSonCompany')"
						value-key="company_id"
						filterable
					>
						<el-option
							v-for="item in listBranchCompany"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item
					label="选择子公司"
					prop="sonCompany"
					v-if="[2, 1].includes(UserInfo.type)"
				>
					<el-select
						v-model="formScreen.sonCompany"
						placeholder="请选择"
						value-key="rid"
						@change="selectChange($event, 'listDepartment')"
						filterable
					>
						<el-option
							v-for="item in listSonCompany"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="选择分部门" prop="departmentValue">
					<el-select
						v-model="formScreen.departmentValue"
						placeholder="请选择"
						value-key="rid"
						@change="selectChange($event, 'listGroup')"
					>
						<el-option
							v-for="item in listDepartment"
							:key="item.rid"
							:label="item.departmentName"
							:value="item"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="选择组" prop="groupValue">
					<el-select
						v-model="formScreen.groupValue"
						placeholder="请选择"
						value-key="rid"
						@change="selectChange($event, 'listStaff')"
					>
						<el-option
							v-for="item in listGroup"
							:key="item.rid"
							:label="item.groupName"
							:value="item"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="选择员工" prop="staffValue">
					<el-select
						v-model="formScreen.staffValue"
						placeholder="请选择"
						value-key="rid"
						@change="selectChange($event, 'none')"
					>
						<el-option
							v-for="item in listStaff"
							:key="item.rid"
							:label="item.roleUserName"
							:value="item"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="商品类型" prop="value">
					<!-- @change="selectChanged" -->
					<el-select v-model="formScreen.value" placeholder="请选择">
						<el-option
							v-for="(item, index) in options2"
							:key="index"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="开始日期" prop="startTime">
					<el-date-picker
						v-model="formScreen.startTime"
						align="right"
						type="date"
						placeholder="选择日期"
						:picker-options="pickerOptions"
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
					></el-date-picker>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="结束日期" prop="endTime">
					<el-date-picker
						v-model="formScreen.endTime"
						align="right"
						type="date"
						placeholder="选择日期"
						:picker-options="pickerOptions"
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
					></el-date-picker>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label=" " prop="input">
					<el-input
						v-model="formScreen.input"
						placeholder="ID、标题、SKU"
						style="width:400px;margin-right:10px;"
						@input="Change_Inp"
						clearable
					></el-input>
					<el-button type="primary" @click="query">
						搜索
					</el-button>
					<el-button type="primary" @click="resetForm"
						>重置</el-button
					>
				</el-form-item>
			</el-col>
		</el-form>
		<el-divider></el-divider>
		<el-row type="flex" align="middle">
			<div class="margin-right-xs">认领到</div>
			<el-select
				class="margin-right-xs"
				@change="claimSelectChange($event, 'listSonCompany2')"
				v-model="formClaim.branchCompany"
				placeholder="请选择分公司"
				value-key="rid"
				v-if="[1].includes(UserInfo.type)"
				filterable
			>
				<el-option
					v-for="item in listBranchCompany2"
					:key="item.rid"
					:label="item.companyName"
					:value="item"
				></el-option>
			</el-select>
			<el-select
				class="margin-right-xs"
				@change="claimSelectChange($event, 'listDepartment2')"
				v-model="formClaim.sonCompany"
				placeholder="请选择子公司"
				value-key="rid"
				v-if="[1, 2].includes(UserInfo.type)"
				filterable
			>
				<el-option
					v-for="item in listSonCompany2"
					:key="item.rid"
					:label="item.companyName"
					:value="item"
				></el-option>
			</el-select>
			<el-select
				class="margin-right-xs"
				@change="claimSelectChange($event, 'listGroup2')"
				v-model="formClaim.departmentValue"
				placeholder="请选择分部门"
				value-key="rid"
				v-if="UserInfo.type === 3 && [1, 2].includes(UserInfo.system)"
			>
				<el-option
					v-for="item in listDepartment2"
					:key="item.rid"
					:label="item.departmentName"
					:value="item"
				></el-option>
			</el-select>
			<el-select
				class="margin-right-xs"
				@change="claimSelectChange($event, 'listStaff2')"
				v-model="formClaim.groupValue"
				placeholder="请选择组"
				value-key="rid"
				v-if="
					UserInfo.type === 3 && [1, 2, 3].includes(UserInfo.system)
				"
			>
				<el-option
					v-for="item in listGroup2"
					:key="item.rid"
					:label="item.groupName"
					:value="item"
				></el-option>
			</el-select>
			<el-select
				class="margin-right-xs"
				@change="claimSelectChange($event, 'none')"
				v-model="formClaim.staffValue"
				placeholder="请选择员工"
				value-key="rid"
				v-if="
					UserInfo.type === 3 &&
						[1, 2, 3, 4, 5].includes(UserInfo.system)
				"
			>
				<el-option
					v-for="item in listStaff2"
					:key="item.rid"
					:label="item.roleUserName"
					:value="item"
				></el-option>
			</el-select>

			<el-button @click="Allelection">全选</el-button>
			<el-button @click="Eliminate">清除选中</el-button>
			<el-button type="primary" @click="claimDone">认领选中</el-button>
		</el-row>

		<ul class="container" v-loading="isLoading" v-if="listData.length != 0">
			<li
				class="product-item margin-top1"
				v-for="item in listData"
				:key="item.id"
			>
				<div
					class="share_li margin-top1"
					:class="{ active: item.isChecked }"
					@click="changeC(item)"
				>
					<div class="claim_img">
						<img :src="item.productImgUrl" alt />
					</div>
					<div class="title">{{ item.title }}</div>
					<div class="claim_li_butoom">
						<div>{{ item.productPrice + item.priceCurrency }}</div>
						<div>
							<span v-if="UserInfo.type === 1">{{
								item.fenName + ' - ' + item.ziName
							}}</span>
							<span v-else-if="UserInfo.type === 2">{{
								item.ziName
							}}</span>
						</div>
						<div>{{ item.userRoleName }}</div>
						<!-- <span @click="moreList(item)">
                            <el-button v-show="!item.moretypr" type="primary" plain>展开</el-button>
                            <el-button v-show="item.moretypr" type="primary" plain>收回</el-button>
                        </span> -->
					</div>
					<div class="claim_li_claim" v-show="item.type == 0">
						<el-button type="primary" plain @click="Claim"
							>认领(1)</el-button
						>
					</div>
					<div class="claim_li_claim" v-show="item.type == 1">
						<el-button type="info" @click="Claim"
							>认领(1)</el-button
						>
					</div>
					<div class="cus-tag claim_li_revised">
						变体({{ item.variantCount }})
					</div>
					<div class="cus-tag claim_li_revisedt">
						被认领({{ item.claimTimes }})
					</div>
					<div
						class="cus-tag claim_li_reviseds green"
						v-if="item.isByUpload === 1"
					>
						已使用
					</div>
					<div class="cus-tag claim_li_reviseds" v-else>未使用</div>
					<div class="cus-tag claim_li_type">
						<div v-if="item.productType === 1">新建</div>
						<div v-else-if="item.productType === 2">认领</div>
						<div v-else-if="item.productType === 3">孵化</div>
						<div v-else-if="item.productType === 4">复制</div>
						<div v-else-if="item.productType === 5">迁移</div>
					</div>
					<div class="checked" v-show="item.isChecked"></div>
				</div>
				<!-- <div
                    v-for="(ele, index) in setlist"
                    :key="index"
                    class="share_li margin-top1"
                    v-show="item.moretypr"
                    :class="{ active: ele.isChecked }"
                    @click="changeC(ele)"
                >
                    <div class="claim_img">
                        <img :src="ele.img" alt />
                    </div>
                    <p>{{ ele.name }}</p>
                    <div class="claim_li_butoom">
                        <span>{{ ele.ma }}</span>
                        <span>{{ ele.di }}</span>
                    </div>
                    <div class="claim_li_claim" v-show="ele.type == 0">
                        <el-button type="primary" plain @click="Claim">认领(1)</el-button>
                    </div>
                    <div class="claim_li_claim" v-show="ele.type == 1">
                        <el-button type="info" @click="Claim">认领(1)</el-button>
                    </div>
                    <div class="claim_li_revised">变体(1)</div>
                    <div class="claim_li_revisedt">已修改</div>
                    <div class="claim_li_reviseds">未使用(1)</div>
                </div> -->
			</li>
		</ul>
		<div class="EmptyBOX" v-else>
			<i class="el-icon-folder-delete"></i>
			<h1>暂无可认领商品</h1>
		</div>
		<div class="pagination-box">
			<el-pagination
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[20, 50, 100, 250, 300]"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page"
				:page-size="size"
				:total="total"
			></el-pagination>
		</div>
		<!-- <el-dialog title="认领选中" :visible.sync="dialogVisible" width="30%">
            <span>是否认领选中编辑</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog">否</el-button>
                <el-button type="primary" @click="edit">是</el-button>
            </span>
        </el-dialog> -->
		<!-- <commodity-frame ref="CommodityFrame"></commodity-frame> -->
	</div>
</template>

<script>
import CommodityFrame from '../product/elasticFrame/commodityFrame.vue'
import { ajaxPost, Baseurl } from '../../../api/api/api'

export default {
	name: 'share',
	components: {
		CommodityFrame,
	},
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
				shortcuts: [
					{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate()
						},
					},
					{
						text: '上一月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-1)
						},
					},
					{
						text: '上两月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-2)
						},
					},
					{
						text: '上三月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-3)
						},
					},
				],
			},
			UserInfo: {},
			formScreen: {
				branchCompany: '',
				sonCompany: '',
				departmentValue: '',
				groupValue: '',
				staffValue: '',
				startTime: '',
				endTime: '',
				input: '',
				value: '',
			},
			listBranchCompany: [],
			listSonCompany: [],
			listDepartment: [],
			listGroup: [],
			listStaff: [],
			page: 1,
			size: 20,
			total: 0,
			companyId: '',
			staffId: '',
			listData: [],

			options: [{ value: '1', label: '我' }],
			formClaim: {
				branchCompany: '',
				sonCompany: '',
				departmentValue: '',
				groupValue: '',
				staffValue: '',
				companyId: '',
				system: '',
				rid: '',
			},
			listBranchCompany2: [],
			listSonCompany2: [],
			listDepartment2: [],
			listGroup2: [],
			listStaff2: [],
			dialogVisible: false,
			isLoading: false,
			// queryType: "1",
			options2: [
				{ value: '1', label: '新建' },
				{ value: '2', label: '认领' },
				{ value: '3', label: '孵化' },
				{ value: '4', label: '复制' },
				{ value: '5', label: '迁移' },
			],
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		if (this.UserInfo.system === 5 && this.listStaff.length === 0) {
			this.listStaff2.push({
				roleUserName: '我',
				company_id: this.UserInfo.company_id,
				rid: this.UserInfo.rid,
				system: this.UserInfo.system,
			})
		}
		this.getThisMonth()
		this.init()
	},
	methods: {
		Change_Inp(value) {
			// console.log(value)
			if (value != '') {
				this.formScreen.startTime = ''
				this.formScreen.endTime = ''
			} else {
				this.getThisMonth()
			}
		},
		getThisMonth() {
			const nowDate = new Date()
			const nowTimeStamp = nowDate.getTime()
			const nowYear = nowDate.getFullYear()
			const nowMonth = nowDate.getMonth() + 1
			const nowDay = nowDate.getDate()

			const startTimeStamp = nowTimeStamp - 3600 * 1000 * 24 * 30
			const startDate = new Date(startTimeStamp)
			const startYear = startDate.getFullYear()
			const startMonth = startDate.getMonth() + 1
			const startDay = startDate.getDate()

			this.formScreen.startTime = `${startYear}-${startMonth}-${startDay} 00:00:00`
			this.formScreen.endTime = `${nowYear}-${nowMonth}-${nowDay} 23:59:59`
		},
		calculationDate(type = 0) {
			const date = new Date()
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDate()
			// 计算新的月份和年份，确保处理负数和跨年的情况
			const newYear = year + Math.floor((month + type - 1) / 12);
			const newMonth = (month + type - 1 + 12) % 12 + 1;
			this.formScreen.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;

			const prevStamp =
				new Date(year, month + type, day).getTime() -
				3600 * 1000 * 24 * day
			const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(
				prevStamp
			).getMonth() + 1}-${new Date(prevStamp).getDate()}`

			this.formScreen.endTime = `${prevMonth} 23:59:59`
			// this.formScreen.endTime = prevMonth;
		},
		handleSizeChange(val) {
			this.size = val
			this.getListData()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getListData()
		},
		query() {
			this.page = 1
			this.size = 20
			// this.queryType = "2";
			this.getListData()
		},
		resetForm() {
			this.page = 1
			this.size = 20
			// this.queryType = "1";
			this.$refs.formScreen.resetFields()
			console.log(this.formScreen)
			this.staffId = ''
			this.listBranchCompany = []
			this.listSonCompany = []
			this.listDepartment = []
			this.listGroup = []
			this.listStaff = []
			this.init()
			this.getListData()
		},
		init() {
			const { rid, system, company_id: companyId, type } = this.UserInfo
			this.companyId = companyId
			// this.staffId = rid;
			system && (this.system = system)
			let listType = ''
			let listType2 = ''
			if (type === 1) {
				listType = 'listBranchCompany'
				listType2 = 'listBranchCompany2'
			} else if (type === 2) {
				listType = 'listSonCompany'
				listType2 = 'listSonCompany2'
			} else {
				listType = 'listDepartment'
				listType2 = 'listDepartment2'
			}
			if (system === 3) {
				listType2 = 'listGroup2'
			} else if (system === 4) {
				listType2 = 'listStaff2'
			}

			this.getNextPower(rid, system, companyId, listType, listType2, true)
			this.getNextPower2(rid, system, companyId, listType2)
			this.getListData()
		},
		getNextPower(
			rid,
			system,
			companyId,
			type,
			type2 = '',
			selectType = false
		) {
			const API = Baseurl + 'roleController/selectCliamByRid'
			const paramsData = { rid, system, companyId }
			if (selectType) {
				paramsData.type = '1'
			} else {
				paramsData.type = '2'
			}
			ajaxPost(API, paramsData).then((res) => {
				const {
					data: { code, data },
				} = res
				if (code === 200) {
					this[type] = data.next
					if (type2) this[type2] = data.next
				}
			})
		},
		getNextPower2(rid, system, companyId, type) {
			const API = Baseurl + 'roleController/selectNextInfoByRid'
			const paramsData = { rid, system, companyId }

			ajaxPost(API, paramsData).then((res) => {
				const {
					data: { code, data },
				} = res
				if (code === 200) {
					this[type] = data.next
				}
			})
		},
		selectChange(event, type) {
			const { rid, system, company_id: companyId } = event
			companyId && (this.companyId = companyId)
			rid && (this.staffId = rid)
			system && (this.system = system)
			if (type === 'none') return
			this.getNextPower(rid, system, companyId, type)

			this.formScreen.staffValue = {}
			this.listStaff = []
			if (type === 'listStaff') return
			this.formScreen.groupValue = {}
			this.listGroup = []
			if (type === 'listGroup') return
			this.formScreen.departmentValue = {}
			this.listDepartment = []
			if (type === 'listDepartment') return
			this.formScreen.sonCompany = {}
			this.listSonCompany = []
		},
		claimSelectChange(event, type) {
			console.log(event)
			const { rid, system, company_id: companyId } = event
			companyId && (this.formClaim.companyId = companyId)
			rid && (this.formClaim.rid = rid)
			system && (this.formClaim.system = system)
			if (type === 'none') return
			this.getNextPower(rid, system, companyId, type)

			this.formClaim.staffValue = {}
			this.listStaff2 = []
			if (type === 'listStaff2') return
			this.formClaim.groupValue = {}
			this.listGroup2 = []
			if (type === 'listGroup2') return
			this.formClaim.departmentValue = {}
			this.listDepartment2 = []
			if (type === 'listDepartment2') return
			this.formClaim.sonCompany = {}
			this.listSonCompany2 = []
		},
		getListData() {
			if (this.formScreen.input != '') {
				if (
					this.formScreen.startTime == null ||
					this.formScreen.endTime == null
				) {
					this.$message({
						type: 'error',
						message: '请选择查询日期',
					})
					return
				}
				var Date1 = Date.parse(this.formScreen.startTime)
				var Date2 = Date.parse(this.formScreen.endTime)
				var days = (Date2 - Date1) / (1 * 24 * 60 * 60 * 1000)
				// console.log(days)
				if (days > 62) {
					this.$message({
						type: 'info',
						message: '日期选择区间不能大于62天，请重新选择！',
					})
					return
				}
				// console.log(this.formScreen.startTime)
				// console.log(this.formScreen.endTime)
			}
			const paramsData = {
				page: this.page,
				size: this.size,
				rid: this.staffId,
				staffId: this.UserInfo.rid,
				companyId: this.companyId,
				startTime: this.formScreen.startTime,
				endTime: this.formScreen.endTime,
				idTitleSku: this.formScreen.input,
				// type: this.queryType,
			}
			const API = Baseurl + 'productController/selectClaimProducts'
			paramsData.productType =
				Number(this.formScreen.value) > 0
					? Number(this.formScreen.value)
					: ''
			this.isLoading = true
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				this.isLoading = false
				if (code === 200) {
					data.list.forEach((item) => (item.isChecked = false))
					this.listData = data.list
					this.total = data.total
				}
			})
		},
		claimDone() {
			const checkedList = this.listData.filter((item) => item.isChecked)
			if (!checkedList.length) {
				this.$message.warning('至少选择一件产品！')
				return
			}
			if (
				!this.formClaim.companyId ||
				!this.formClaim.system ||
				!this.formClaim.rid
			) {
				this.$message.warning('请选择认领对象！')
				return
			}
			if (
				this.UserInfo.type === 3 &&
				!Object.keys(this.formClaim.staffValue).length
			) {
				this.$message.warning('请分配到员工！')
				return
			}

			// const handleRequest = () => {
			//     const ids = checkedList.map(item => item.id);
			//     const API = Baseurl + "productController/claimProduct";
			//     const paramsData = {
			//         ids,
			//         companyId: this.formClaim.companyId,
			//         system: this.formClaim.system,
			//         rid: this.formClaim.rid,
			//     };
			//     ajaxPost(API, paramsData).then(res => {
			//         const { code, message } = res.data;
			//         if (code === 200) {
			//             this.$message.success("操作成功");
			//             this.getListData();
			//         } else {
			//             this.$message.error(message);
			//         }
			//     });
			// };
			this.$confirm('是否认领选中？', '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true
						instance.confirmButtonText = '认领中...'
						const ids = checkedList.map((item) => item.id)
						const API = Baseurl + 'productController/claimProduct'
						const paramsData = {
							ids,
							companyId: this.formClaim.companyId,
							system: this.formClaim.system,
							rid: this.formClaim.rid,
						}
						ajaxPost(API, paramsData).then((res) => {
							const { code, message } = res.data
							if (code === 200) {
								this.$message.success('认领成功')
								instance.confirmButtonLoading = false
								done()
								this.getListData()
							} else {
								this.$message.error(message)
							}
						})
					} else {
						done()
					}
				},
			}).then(() => {
				//  done();
			})
		},
		changeC(item) {
			item.isChecked = !item.isChecked
		},
		Allelection() {
			this.listData.forEach((item) => (item.isChecked = true))
		},
		Eliminate() {
			this.listData.forEach((item) => (item.isChecked = false))
		},
		moreList(item) {
			item.moretypr = !item.moretypr
		},
		// dialog() {
		//     this.dialogVisible = false;
		//     this.$message("认领成功");
		// },
		Claim() {
			this.dialogVisible = true
		},
		// edit() {
		//     this.dialogVisible = false;
		//     this.$refs.CommodityFrame.init(); //子级的init
		// },
	},
}
</script>

<style lang="scss" scoped>
.share {
	width: 98%;
	padding-bottom: 72px;
	.el-select {
		width: 220px;
	}
	.el-form-item {
		margin: 0;
	}
	.margin-right-xs {
		margin-right: 10px;
	}
	.container {
		min-height: 500px;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;
		.product-item {
			width: 24%;
			margin-right: 1%;
		}
		.share_li {
			height: 390px;
			border: 1px solid #ccc;
			position: relative;
			overflow: hidden;
			&.active {
				border: 1px solid #67c23a;
			}
			.claim_img {
				width: 270px;
				height: 270px;
				margin: 0 auto;
				overflow: hidden;
				img {
					width: 100%;
				}
			}
			.title {
				height: 57px;
				padding: 0 20px;
				word-break: break-word;
				display: -webkit-box; /* autoprefixer:off */
				-webkit-box-orient: vertical;
				overflow: hidden;
				-webkit-line-clamp: 3;
			}
			.claim_li_butoom {
				width: 90%;
				margin: 20px 0;
				padding: 0 20px;
				overflow: hidden;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			.cus-tag {
				position: absolute;
				left: -8px;
				padding: 5px 10px 5px 14px;
				background: #2c8dff;
				color: #fff;
				transform: rotate(21deg);
				-webkit-transform: rotate(21deg);
				&.claim_li_revised {
					top: 20px;
				}
				&.claim_li_revisedt {
					top: 110px;
				}
				&.claim_li_reviseds {
					top: 60px;
					background: #ff2c40;
					&.green {
						background: #67c23a;
					}
				}
				&.claim_li_type {
					padding: 5px 14px 5px 10px;
					left: initial;
					right: -8px;
					top: 50px;
					transform: rotate(-21deg);
				}
			}
			.claim_li_claim {
				position: absolute;
				top: 7%;
				right: 3%;
				padding: 5px 10px;
			}
			.checked {
				width: 70px;
				height: 70px;
				background: #67c23a;
				position: absolute;
				right: -35px;
				top: -35px;
				z-index: 99;
				transform: rotate(-45deg);
				user-select: none;
				&::before {
					content: '√';
					font-size: 20px;
					font-weight: bold;
					color: #fff;
					position: absolute;
					top: 0;
					left: 5px;
					line-height: 70px;
					transform: rotate(45deg);
				}
			}
		}
	}
	.pagination-box {
		width: 1789px;
		padding: 20px;
		position: fixed;
		right: 0;
		bottom: 0;
		background: #fff;
		z-index: 999;
		.el-pagination {
			display: flex;
			justify-content: center;
		}
	}
}
.EmptyBOX {
	padding-top: 150px;
	text-align: center;
	// line-height: 50px;
	i {
		font-size: 130px;
		color: rgb(134, 132, 132);
	}
	h1 {
		color: #ccc;
	}
}
</style>
